import { Radio } from 'antd';
import classNames from 'classnames';
import styles from './segmented-toggle.module.scss';

/**
 * @param {{
 *   value: string,
 *   onChange: (value: string) => void,
 *   options: Array<{ label: React.ReactNode, value: string }>,
 *   size?: 'small' | 'middle' | 'large',
 *   className?: string,
 * }} props
 */
export function SegmentedToggle({ value, onChange, options, size = 'middle', className }) {
  return (
    <Radio.Group
      size={size}
      buttonStyle="solid"
      value={value}
      onChange={e => onChange(e.target.value)}
      className={classNames(styles.toggle, className)}>
      {options.map(option => (
        <Radio.Button key={option.value} className={styles.button} value={option.value}>
          {option.label}
        </Radio.Button>
      ))}
    </Radio.Group>
  );
}
